import { Button } from "@website/ui/button";
import { useCounterButton } from "@website/ui/counter-button/counter-button.hook";
import styles from "@website/ui/counter-button/counter-button.module.scss";
import { CounterButtonPropertiesType } from "@website/ui/counter-button/counter-button.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const CounterButton: FC<CounterButtonPropertiesType> = (properties) => {
  const {
    className,
    variant,
    decreaseDisabled,
    increaseDisabled,
    helperText,
    error,
    size = "medium"
  } = properties;
  const {
    value,
    rootProps,
    decreaseButtonProps,
    increaseButtonProps,
    valueProps
  } = useCounterButton(properties);

  return (
    <>
      <div
        {...rootProps}
        className={`${styles["counter-button"]} ${
          styles[variant ?? "contained"]
        } ${className ?? ""}`}
      >
        <Button {...increaseButtonProps} size={size} type="button" />
        <div {...valueProps} className={styles["value"]}>
          {value}
        </div>
        <Button {...decreaseButtonProps} size={size} type="button" />
      </div>
      {helperText ? (
        <div
          className={`${styles["helper-text"]} ${
            decreaseDisabled && increaseDisabled && styles.disabled
          } ${error && styles.error}`}
        >
          {helperText}
        </div>
      ) : null}
    </>
  );
};

const CounterButtonMemoized = memo(CounterButton, deepCompare);
export { CounterButtonMemoized as CounterButton };
